import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const POPULATION_METRICS_AU = [
  {
    groupMetricId: ' ',
    groupMetricSize: 1,
    metricId: '1002',
    displayName: 'Male Population',
    definition:
      'The number of Male People for the geographical area. This is an aggregated value. This metric is available in 2006, 2011, 2016, 2021',
  },
  {
    groupMetricId: '120',
    groupMetricSize: 11,
    metricId: '1012',
    displayName: 'Male Population: 0-9',
    definition:
      'The percentage of the Male population that falls within 0-9 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1013',
    displayName: 'Male Population: 10-19',
    definition:
      'The percentage of the Male population that falls within 10-19 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1014',
    displayName: 'Male Population: 20-29',
    definition:
      'The percentage of the Male population that falls within 20-29 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1015',
    displayName: 'Male Population: 30-39',
    definition:
      'The percentage of the Male population that falls within 30-39 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1016',
    displayName: 'Male Population: 40-49',
    definition:
      'The percentage of the Male population that falls within 40-49 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1017',
    displayName: 'Male Population: 50-59',
    definition:
      'The percentage of the Male population that falls within 50-59 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1018',
    displayName: 'Male Population: 60-69',
    definition:
      'The percentage of the Male population that falls within 60-69 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1019',
    displayName: 'Male Population: 70-79',
    definition:
      'The percentage of the Male population that falls within 70-79 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1020',
    displayName: 'Male Population: 80-89',
    definition:
      'The percentage of the Male population that falls within 80-89 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1273',
    displayName: 'Male Population: 90-99',
    definition:
      'The percentage of the Male population that falls within 90-99 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1274',
    displayName: 'Male Population: 100+',
    definition:
      'The percentage of the Male population that is 100+ years of age and over for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    groupMetricId: ' ',
    groupMetricSize: 1,
    metricId: '1021',
    displayName: 'Female Population',
    definition:
      'The number of Female people for the geographical area. This is an aggregated value. This metric is available in 2006, 2011, 2016, 2021',
  },
  {
    groupMetricId: '121',
    groupMetricSize: 11,
    metricId: '1031',
    displayName: 'Female Population: 0-9',
    definition:
      'The percentage of the Female population that falls within 0-9 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1032',
    displayName: 'Female Population: 10-19',
    definition:
      'The percentage of the Female population that falls within 10-19 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1033',
    displayName: 'Female Population: 20-29',
    definition:
      'The percentage of the Female population that falls within 20-29 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1034',
    displayName: 'Female Population: 30-39',
    definition:
      'The percentage of the Female population that falls within 30-39 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1035',
    displayName: 'Female Population: 40-49',
    definition:
      'The percentage of the Female population that falls within 40-49 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1036',
    displayName: 'Female Population: 50-59',
    definition:
      'The percentage of the Female population that falls within 50-59 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1037',
    displayName: 'Female Population: 60-69',
    definition:
      'The percentage of the Female population that falls within 60-69 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1038',
    displayName: 'Female Population: 70-79',
    definition:
      'The percentage of the Female population that falls within 70-79 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1039',
    displayName: 'Female Population: 80-89',
    definition:
      'The percentage of the Female population that falls within 80-89 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1276',
    displayName: 'Female Population: 90-99',
    definition:
      'The percentage of the Female population that falls within 90-99 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1277',
    displayName: 'Female Population: 100+',
    definition:
      'The percentage of the Female population that is 100+ years of age and over for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    groupMetricId: ' ',
    groupMetricSize: 1,
    metricId: '1244',
    displayName: 'Population',
    definition:
      'The number of people for the geographical area. This is an aggregated value. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    groupMetricId: '100',
    groupMetricSize: 11,
    metricId: '1254',
    displayName: 'Population: 0-9',
    definition:
      'The percentage of the population that falls within 0-9 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1255',
    displayName: 'Population: 10-19',
    definition:
      'The percentage of the population that falls within 10-19 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1256',
    displayName: 'Population: 20-29',
    definition:
      'The percentage of the population that falls within 20-29 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1257',
    displayName: 'Population: 30-39',
    definition:
      'The percentage of the population that falls within 30-39 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1258',
    displayName: 'Population: 40-49',
    definition:
      'The percentage of the population that falls within 40-49 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1259',
    displayName: 'Population: 50-59',
    definition:
      'The percentage of the population that falls within 50-59 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1260',
    displayName: 'Population: 60-69',
    definition:
      'The percentage of the population that falls within 60-69 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1261',
    displayName: 'Population: 70-79',
    definition:
      'The percentage of the population that falls within 70-79 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1262',
    displayName: 'Population: 80-89',
    definition:
      'The percentage of the population that falls within 80-89 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1270',
    displayName: 'Population: 90-99',
    definition:
      'The percentage of the population that falls within 90-99 years of age for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1271',
    displayName: 'Population: 100+',
    definition:
      'The percentage of the population that is 100+ years of age and over for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const POPULATION_METRICS_NZ = [
  {
    groupMetricId: ' ',
    groupMetricSize: 1,
    metricId: '1201',
    displayName: 'Population',
    definition: 'The number of people for the geographical area. This is an aggregated value. This metric is available for 2023.',
  },
  {
    groupMetricId: '113',
    groupMetricSize: 19,
    metricId: '1430',
    displayName: 'Population: 0-4',
    definition:
      'The percentage of the population that falls within 0-4 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1431',
    displayName: 'Population: 5-9',
    definition:
      'The percentage of the population that falls within 5-9 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1432',
    displayName: 'Population: 10-14',
    definition:
      'The percentage of the population that falls within 10-14 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1433',
    displayName: 'Population: 15-19',
    definition:
      'The percentage of the population that falls within 15-19 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1434',
    displayName: 'Population: 20-24',
    definition:
      'The percentage of the population that falls within 20-24 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1435',
    displayName: 'Population: 25-29',
    definition:
      'The percentage of the population that falls within 25-29 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1436',
    displayName: 'Population: 30-34',
    definition:
      'The percentage of the population that falls within 30-34 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1437',
    displayName: 'Population: 35-39',
    definition:
      'The percentage of the population that falls within 35-39 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1438',
    displayName: 'Population: 40-44',
    definition:
      'The percentage of the population that falls within 40-44 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1439',
    displayName: 'Population: 45-49',
    definition:
      'The percentage of the population that falls within 45-49 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1440',
    displayName: 'Population: 50-54',
    definition:
      'The percentage of the population that falls within 50-54 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1441',
    displayName: 'Population: 55-59',
    definition:
      'The percentage of the population that falls within 55-59 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1442',
    displayName: 'Population: 60-64',
    definition:
      'The percentage of the population that falls within 60-64 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1443',
    displayName: 'Population: 65-69',
    definition:
      'The percentage of the population that falls within 65-69 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1444',
    displayName: 'Population: 70-74',
    definition:
      'The percentage of the population that falls within 70-74 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1445',
    displayName: 'Population: 75-79',
    definition:
      'The percentage of the population that falls within 75-79 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1446',
    displayName: 'Population: 80-84',
    definition:
      'The percentage of the population that falls within 80-84 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1447',
    displayName: 'Population: 85-89',
    definition:
      'The percentage of the population that falls within 85-89 years of age for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1448',
    displayName: 'Population: 90+',
    definition:
      'The percentage of the population that is 90 years of age and over for the geographical area. This metric is available for 2023.',
  },
];

export const PopulationMetrics = () => {
  const country = useRootStore(state => state.country);

  const metrics = [
    {
      title: 'Population',
      data: country === 'au' ? POPULATION_METRICS_AU : POPULATION_METRICS_NZ,
    },
  ];

  return (
    <div>
      <Typography
        id="population-metrics"
        variant="h6"
        fontWeight={600}
        my={0.5}
      >
        Population Metrics
      </Typography>

      <Typography variant="body2">
        The Population Metrics relate to the population count and gender ratio
        for particular location.
      </Typography>

      <br />

      <Stack gap={4}>
        {metrics
          .filter(metric => metric.data.length > 0)
          .map(metric => (
            <div>
              <Typography variant="body2" fontWeight={600}>
                {metric.title}
              </Typography>

              <br />

              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ whiteSpace: 'nowrap' }}>
                    <TableRow>
                      <TableCell>Group Metric ID</TableCell>
                      <TableCell>Metric ID</TableCell>
                      <TableCell>Display Name</TableCell>
                      <TableCell>Definition</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metric.data.map(data => (
                      <TableRow key={data.metricId}>
                        {data.groupMetricId && (
                          <TableCell
                            rowSpan={data.groupMetricSize || metric.data.length}
                          >
                            {data.groupMetricId}
                          </TableCell>
                        )}
                        <TableCell>{data.metricId}</TableCell>
                        <TableCell>{data.displayName}</TableCell>
                        <TableCell>{data.definition}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ))}
      </Stack>
    </div>
  );
};
